import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function GlassSign(props) {
  const { nodes, materials } = useGLTF('./models/404.glb')
  return (
    <group {...props} dispose={null} rotation-x={ 90 * Math.PI / 180 } position-y={1} position-z={4.45}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text.geometry}
        material={nodes.Text.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text002.geometry}
        material={nodes.Text002.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text003.geometry}
        material={nodes.Text003.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text004.geometry}
        material={nodes.Text004.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text005.geometry}
        material={nodes.Text005.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text006.geometry}
        material={nodes.Text006.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text007.geometry}
        material={nodes.Text007.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text008.geometry}
        material={nodes.Text008.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text009.geometry}
        material={nodes.Text009.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text010.geometry}
        material={nodes.Text010.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text011.geometry}
        material={nodes.Text011.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text012.geometry}
        material={nodes.Text012.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text013.geometry}
        material={nodes.Text013.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text014.geometry}
        material={nodes.Text014.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text015.geometry}
        material={nodes.Text015.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text016.geometry}
        material={nodes.Text016.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text017.geometry}
        material={nodes.Text017.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text018.geometry}
        material={nodes.Text018.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text019.geometry}
        material={nodes.Text019.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text020.geometry}
        material={nodes.Text020.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text021.geometry}
        material={nodes.Text021.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text022.geometry}
        material={nodes.Text022.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text023.geometry}
        material={nodes.Text023.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text024.geometry}
        material={nodes.Text024.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text025.geometry}
        material={nodes.Text025.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text026.geometry}
        material={nodes.Text026.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text027.geometry}
        material={nodes.Text027.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text028.geometry}
        material={nodes.Text028.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Text029.geometry}
        material={nodes.Text029.material}
      />
    </group>
  )
}

useGLTF.preload('./models/404.glb')
